import { render, staticRenderFns } from "./specificResponse.vue?vue&type=template&id=9e028da4&scoped=true"
import script from "./specificResponse.vue?vue&type=script&lang=js"
export * from "./specificResponse.vue?vue&type=script&lang=js"
import style0 from "./specificResponse.vue?vue&type=style&index=0&id=9e028da4&prod&lang=less"
import style1 from "./specificResponse.vue?vue&type=style&index=1&id=9e028da4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e028da4",
  null
  
)

export default component.exports